import { ApiResponse } from "../models/api-response";
import {
  CandidateFeedback,
  CandidateFeedbackFormData,
  CandidateFeedbackStatusResponse,
} from "../models/feedback";
import { callApi } from "./api.service";
import { AverageRating } from "../types/feedback.types";

const apiServerUrl = import.meta.env.VITE_API_SERVER_URL;

export const getCandidateFeedbackStatus = async (
  invitationToken: string
): Promise<ApiResponse<CandidateFeedbackStatusResponse>> => {
  return callApi<CandidateFeedbackStatusResponse>(
    `${apiServerUrl}/api/interviews/${invitationToken}/feedback`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const submitCandidateFeedback = async (
  invitationToken: string,
  payload: CandidateFeedbackFormData
): Promise<ApiResponse<CandidateFeedback>> => {
  return callApi<CandidateFeedback>(
    `${apiServerUrl}/api/interviews/${invitationToken}/feedback`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
};

/**
 * Fetches the average rating across all candidate feedback entries.
 * @param accessToken - The user's access token.
 * @returns Promise resolving to an ApiResponse containing the average rating.
 */
export const getAverageRating = async (
  accessToken: string
): Promise<ApiResponse<AverageRating>> => {
  const config: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return callApi<AverageRating>(
    `${apiServerUrl}/api/interviews/feedback/average-rating`,
    config
  );
};